import React, { Component } from 'react';
import './App.css';
import Main from './Infos/main'
import 'semantic-ui-css/semantic.min.css'

class App extends Component {
  componentDidMount(){
    document.title = "CT Weng"
  }
  render() {
    return (
      <div className="App">
        <Main/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js